import React, { useEffect, useState } from 'react';
import { searchBanks } from '../api/banks';
import './LotterySearchModal.css';

const BankSearchModal = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    let cancelled = false;
    searchBanks('')
      .then((data) => { if (!cancelled) setResults(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleSearch = () => {
    searchBanks(query).then(setResults).catch(() => {});
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="lsm-overlay">
      <div className="lsm-modal">
        <div className="lsm-header">
          <button className="lsm-close-btn" onClick={onClose}></button>
        </div>

        <div className="lsm-body">
          <p className="lsm-search-by">Search By:</p>
          <div className="lsm-radio-row">
            <label className="lsm-radio-label">
              <input type="radio" name="searchBy" defaultChecked readOnly />
              Name
            </label>
            <input
              className="lsm-name-input"
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>

          <div className="lsm-search-row">
            <input
              className="lsm-search-input"
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button className="lsm-search-btn" onClick={handleSearch}>Search</button>
          </div>

          <div className="lsm-table-wrapper">
            <table className="lsm-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Nom</th>
                </tr>
              </thead>
              <tbody>
                {results.map((row) => (
                  <tr
                    key={row.id}
                    className="lsm-row"
                    onClick={() => { onSelect(row.id, row.name, row.username, row.seq); onClose(); }}
                  >
                    <td>{row.seq ?? '—'}</td>
                    <td>{row.username || '—'}</td>
                    <td>{row.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="lsm-footer">
          <button className="lsm-cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default BankSearchModal;
